export default {
    SHA1: 20,
    SHA256: 32,
    SHA512: 64
};
//# sourceMappingURL=lengths.js.map